/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/* eslint-disable no-param-reassign */
import { types } from 'mobx-state-tree';

// Define a single ProjectAssociation model
const ProjectAssociation = types.model('ProjectAssociation', {
  instituteID: types.maybeNull(types.string),
  lineOfBusiness: types.maybeNull(types.string),
  // projects can be "all" or an array of entityURNs
  projects: types.maybeNull(
    types.union(types.string, types.array(types.string))
  ),
  isAdmin: types.maybeNull(types.boolean)
});

export default ProjectAssociation;
